import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-s3listfile',
  templateUrl: './s3listfile.component.html',
  styleUrls: ['./s3listfile.component.css']
})
export class S3listfileComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;
  
  constructor() { }

  ngOnInit(): void {
  }

  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
       this.copyButton = false;
       this.copiedButton = true;
  // After a few seconds, reset the button states
      setTimeout(() => {
        this.copyButton = true;
        this.copiedButton = false;
      }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.requestData);
  }


  requestData =
  `
  curl 'https://api.optimusdrive.ai/v1/s3/files?path=Videos_for_Optimization/'   -H 'authorization: XXX'
  
  `

  sucessData = `
  {
    "data": {
      "files": [
        {
          "type": "file",
          "path": "Videos_for_Optimization/sample1.jpg",
          "name": "switzerland-7543063_1920.jpg",
          "size": 272501,
          "last_modified": "2023-06-08 06:10:03 +0000 UTC"
        },
        {
          "type": "file",
          "path": "Videos_for_Optimization/s2.jpg",
          "name": "vietnam-6634082_640.jpg",
          "size": 150399,
          "last_modified": "2023-06-08 06:10:03 +0000 UTC"
        }
      ],
      "cursor": ""
    },
    "message": "Files fetched successfully"
  }`

  Error5x = `
  {
    "error": {},
    "message": "string"
  }
  `
  Error4x = `
  {
    "error": "unable to generate token",
    "message": "Something went wrong!"
  }`

  Error401x = `
  {
    "error": {},
    "message": "Unauthorized"
  }
  `



}
